import React, { useState } from 'react';
import { X, Play } from 'lucide-react';
import { mediaSrc } from '../../admin/guidebook/uploadMedia';

const Tile = ({ item, onOpen, testId }) => (
  <button type="button" data-testid={testId} onClick={() => onOpen(item)} className="relative aspect-video rounded-lg overflow-hidden bg-slate-800 group text-left">
    {item.type === 'image' && <img src={mediaSrc(item.url)} alt={item.caption || 'Property photo'} loading="lazy" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />}
    {item.type === 'video' && <video src={`${mediaSrc(item.url)}#t=0.1`} className="w-full h-full object-cover" muted playsInline preload="metadata" />}
    {item.type === 'embed' && <iframe title={item.caption || 'Video'} src={item.url} className="w-full h-full pointer-events-none" />}
    {item.type !== 'image' && <span className="absolute inset-0 flex items-center justify-center"><span className="w-10 h-10 rounded-full bg-amber-500/90 flex items-center justify-center"><Play className="h-5 w-5 text-slate-900 ml-0.5" /></span></span>}
    {item.caption && <span className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent text-white text-xs px-2 py-1.5 truncate">{item.caption}</span>}
  </button>
);

export const MediaGrid = ({ items = [], testId = 'media' }) => {
  const [active, setActive] = useState(null);
  if (!items.length) return null;
  return (
    <>
      <div className={`grid gap-2 ${items.length === 1 ? 'grid-cols-1' : 'grid-cols-2'}`} data-testid={`${testId}-grid`}>
        {items.map((item, i) => <Tile key={item.id || i} item={item} onOpen={setActive} testId={`${testId}-tile-${i}`} />)}
      </div>
      {active && (
        <div data-testid={`${testId}-lightbox`} className="fixed inset-0 z-50 bg-black/95 flex flex-col items-center justify-center p-3" onClick={() => setActive(null)}>
          <button type="button" data-testid={`${testId}-lightbox-close`} aria-label="Close" className="absolute top-4 right-4 text-white/80 hover:text-white" onClick={() => setActive(null)}><X className="h-7 w-7" /></button>
          <div className="w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            {active.type === 'image' && <img src={mediaSrc(active.url)} alt={active.caption || ''} className="w-full max-h-[80vh] object-contain rounded-lg" />}
            {active.type === 'video' && <video src={mediaSrc(active.url)} controls autoPlay playsInline className="w-full max-h-[80vh] rounded-lg bg-black" />}
            {active.type === 'embed' && <div className="aspect-video"><iframe title={active.caption || 'Video'} src={`${active.url}?autoplay=1`} className="w-full h-full rounded-lg" allow="autoplay; fullscreen" allowFullScreen /></div>}
            {active.caption && <p className="text-slate-300 text-sm text-center mt-3">{active.caption}</p>}
          </div>
        </div>
      )}
    </>
  );
};
